// PharmacyMap.jsx
import React, { useEffect, useRef, useState } from 'react';
import mapMarker from '../../images/user/i_map_marker.svg';
import mapMyposition from '../../images/user/i_my_position.svg';
import mapMypositionLarge from '../../images/user/i_my_position_lg.svg';
import mapMarkerHit from '../../images/user/i_map_marker_hit.svg';
import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import PharmacyDetailsBox from './PharmacyDetailsBox';

const PharmacyMap = ({ currentPosition, pharmacies }) => {
  const mapRef = useRef(null);
  const naverMapRef = useRef(null);
  const markersRef = useRef([]);
  const activeMarkerRef = useRef(null);
  const myLocationMarkerRef = useRef(null);

  const [selectedPharmacy, setSelectedPharmacy] = useState(null);
  const [open, setOpen] = useState(false);

  const myPosition = currentPosition ? { lat: currentPosition.lat, lng: currentPosition.lng } : null;

  
  // 지도 초기화
  useEffect(() => {
    if (!window.naver || !mapRef.current || !currentPosition) return;

    const map = new window.naver.maps.Map(mapRef.current, {
      center: new window.naver.maps.LatLng(currentPosition.lat, currentPosition.lng),
      zoom: 15,
    });
    naverMapRef.current = map;

    // 내 위치 마커
    if (!myLocationMarkerRef.current) {
      myLocationMarkerRef.current = new window.naver.maps.Marker({
        position: new window.naver.maps.LatLng(currentPosition.lat, currentPosition.lng),
        map,
        icon: { url: mapMypositionLarge, size: new window.naver.maps.Size(26, 26), anchor: new window.naver.maps.Point(13, 13) },
      });
    }
    // 내 위치 버튼 생성
    const buttonDiv = document.createElement('div');
    buttonDiv.style.position = 'absolute';
    buttonDiv.style.top = '16px';
    buttonDiv.style.right = '16px';
    buttonDiv.style.zIndex = 1000;

    const button = document.createElement('button');
    button.style.background = '#fff';
    button.style.border = '1px solid #ccc';
    button.style.borderRadius = '20px';
    button.style.boxShadow = 'rgba(0, 0, 0, 0.3) 0px 1px 2px';
    button.style.padding = '4px 8px';
    button.style.cursor = 'pointer';
    button.style.display = 'flex';
    button.style.alignItems = 'center';
    button.style.gap = '4px';

    const img = document.createElement('img');
    img.src = mapMyposition;
    img.style.width = '16px';
    img.style.height = '16px';

    const span = document.createElement('span');
    span.textContent = '내 위치';

    button.appendChild(img);
    button.appendChild(span);
    buttonDiv.appendChild(button);
    mapRef.current.appendChild(buttonDiv);

    // 내 위치 버튼 클릭 시 이동
    button.addEventListener('click', () => {
      if (!myPosition) return;

      const latLng = new window.naver.maps.LatLng(myPosition.lat, myPosition.lng);
      map.panTo(latLng);

      if (myLocationMarkerRef.current) myLocationMarkerRef.current.setMap(null);

      myLocationMarkerRef.current = new window.naver.maps.Marker({
        position: latLng,
        map,
        icon: {
          url: mapMypositionLarge,
          size: new window.naver.maps.Size(26, 26),
          anchor: new window.naver.maps.Point(13, 13),
        },
      });
    });
  }, [currentPosition]);

  // 약국 마커 생성
  useEffect(() => {
    if (!naverMapRef.current || pharmacies.length === 0) return;

    // 기존 마커 제거
    markersRef.current.forEach(marker => marker.setMap(null));
    markersRef.current = [];

    pharmacies.forEach(pharmacy => {
      const createMarkerContent = (active = false) => `
        <div style="display:flex; flex-direction:column; align-items:center;">
          <img src="${active ? mapMarkerHit : mapMarker}" style="width:${active ? 42 : 32}px; height:${active ? 52.77 : 32}px;" />
          <div style="
            margin-top:2px;
            font-size: 13px;
            font-weight: bold;
            color: #000;
            text-shadow: -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff;
            white-space: nowrap;
            text-align: center;
          ">${pharmacy.name}</div>
        </div>
      `;

      const marker = new window.naver.maps.Marker({
        position: new window.naver.maps.LatLng(pharmacy.lat, pharmacy.lng),
        map: naverMapRef.current,
        title: pharmacy.name,
        icon: { content: createMarkerContent(false), size: new window.naver.maps.Size(32, 32), anchor: new window.naver.maps.Point(16, 32) },
      });

      marker.addListener('click', () => {
        // 이전 마커 초기화
        if (activeMarkerRef.current && activeMarkerRef.current !== marker) {
          activeMarkerRef.current.setIcon({
            content: createMarkerContent(false),
            size: new window.naver.maps.Size(32, 32),
            anchor: new window.naver.maps.Point(16, 32),
          });
        }

        // 선택 마커 강조
        marker.setIcon({
          content: createMarkerContent(true),
          size: new window.naver.maps.Size(42, 52.77),
          anchor: new window.naver.maps.Point(21, 52.77),
        });

        activeMarkerRef.current = marker;
        setSelectedPharmacy(pharmacy);
        setOpen(true);

        naverMapRef.current.setCenter(marker.getPosition());
      });

      markersRef.current.push(marker);
    });
  }, [pharmacies]);

  // selectedPharmacy 강조 유지
  useEffect(() => {
    if (!selectedPharmacy) return;

    const targetMarker = markersRef.current.find(m => m.getTitle() === selectedPharmacy.name);
    if (targetMarker && activeMarkerRef.current !== targetMarker) {
      const createMarkerContent = (active = false) => `
        <div style="display:flex; flex-direction:column; align-items:center;">
          <img src="${active ? mapMarkerHit : mapMarker}" style="width:${active ? 42 : 32}px; height:${active ? 52.77 : 32}px;" />
          <div style="
            margin-top:2px;
            font-size: 13px;
            font-weight: bold;
            color: #000;
            text-shadow: -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff;
            white-space: nowrap;
            text-align: center;
          ">${targetMarker.getTitle()}</div>
        </div>
      `;

      if (activeMarkerRef.current) {
        activeMarkerRef.current.setIcon({
          content: createMarkerContent(false),
          size: new window.naver.maps.Size(32, 32),
          anchor: new window.naver.maps.Point(16, 32),
        });
      }

      targetMarker.setIcon({
        content: createMarkerContent(true),
        size: new window.naver.maps.Size(42, 52.77),
        anchor: new window.naver.maps.Point(21, 52.77),
      });

      activeMarkerRef.current = targetMarker;
      naverMapRef.current.setCenter(targetMarker.getPosition());
    }
  }, [selectedPharmacy]);

  return (
    <>
      <div ref={mapRef} style={{ width: '100%', height: '100%' }} className="naver-map-box" />

      {selectedPharmacy && (
        <BottomSheet
          scrollLocking={false}
          expandOnContentDrag={false}
          open={open}
          onDismiss={() => setOpen(false)}
          snapPoints={({ minHeight }) => minHeight}
          blocking={true}
        >
          <PharmacyDetailsBox 
            pharmacy={selectedPharmacy} 
            onClose={() => setOpen(false)} 
            hospitalCode="012" // 추후 진료 받은 병원 코드 추가 !!!!
            />
        </BottomSheet>
      )}
    </>
  );
};

export default PharmacyMap;
